module.exports = __webpack_public_path__ + "8328a166ba60e3383ba5f2871b3c5bee.woff2";